import { createStructuredSelector, createSelector } from 'reselect';
import { connect } from 'react-redux';
import { getBotspec } from 'data/selectors';
import { isNotEmpty } from 'utils';
import SpecDropdownView from './SpecDropdownView';

const buildNodes = (key, prefix, nodes) => ({
  key,
  label: key.charAt(0).toUpperCase() + key.slice(1),
  nodes: Object.keys(nodes).reduce((accum, id) => {
    accum.push({ key: `${prefix}${id}`, label: id });
    return accum;
  }, []),
});

const treeData = createSelector(
  getBotspec,
  (botspec) => {
    const specJson = botspec && botspec.spec_json ? botspec.spec_json : {};

    if (isNotEmpty(specJson)) {
      const { variables } = specJson;
      return [
        { ...buildNodes('user', 'user_', variables.user) },
        { ...buildNodes('chatbot', '_', variables.chatbot) },
        { ...buildNodes('session', '', variables.session) },
      ];
    }

    return [];
  },
);

const mapStateToProps = () => createStructuredSelector({
  treeData,
});

export default connect(mapStateToProps)(SpecDropdownView);
